import React, { useEffect, useState, setShow } from "react";
import {
  Row,
  Card,
  Col,
  Button,
  Nav,
  Modal,
  Table,
  InputGroup,
  FormControl,
  Spinner,
} from "react-bootstrap";
import Switch from "react-switch";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { CSVLink, CSVDownload } from "react-csv";
// import { ExcelRenderer } from "react-excel-renderer";
function RiderAcceptDetails(props) {
  // const [cityName, setCityName] = useState("");
  // const [picture, setPicture] = useState(null);
  // const [emmission, setEmmission] = useState(null);
  // const [concerned, setConcerned] = useState(null);
  // const [health, setHealth] = useState(null);
  // const [police, setPolice] = useState(null);
  // const [vehicle, setVehicle] = useState(null);
  // const [altNumber, setAltNumber] = useState("");
  // const [branchId, setBranchId] = useState("");
  // const [yearOfExp, setYearOfExp] = useState("");
  // const [isSmoke, setIsSmoke] = useState("");
  // const [uploadData, setUploadData] = useState("");

  // const [search, setSearch] = useState("");
  // const [districtForSearch, setDistrictForSearch] = useState([]);

  // const [show2, setShow2] = useState(false);

  // const [statepincodes, setstatepincodes] = useState([]);
  // const [showdictpincodes, setshowdictpincodes] = useState([]);
  // const [showdistricts, setshowdistricts] = useState("false");
  // const [showdictpincodes1, setshowdictpincodes1] = useState("false");
  // const [showstates, setshowstates] = useState("true");
  // const [pincodes1, setpincodes1] = useState([]);
  const [riderListData, setRiderListData] = useState([]);
  const [onboardDetails, setOnboardDetails] = useState("");
  const [onboardId, setOnboardId] = useState("");
  const [amount, setAmount] = useState("");
  const [geoView, setGeoView] = useState(false);
  const [rejectSpinner, setRejectSpinner] = useState(false);
  const [riderDetailsImage, setRiderDetailsImage] = useState([]);
  const [forSearch, setForSearch] = useState([]);
  const [imgArray, setImgArray] = useState([]);
  const [pincodes, setpincodes] = useState([]);
  const [geoPincodes, setGeoPincodes] = useState([]);
  const [view, setView] = useState(false);
  const [stateForSearch, setStateForSearch] = useState([]);
  const [viewimage, setViewImage] = useState();
  const [viewStatus, setViewStatus] = useState(false);
  const [riderData, setRiderData] = useState([]);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [rejectreason, setrejectreason] = useState("");
  const [RiderVehicleType, setRiderVehicleType] = useState([]);
  const [RiderGeofence, setRiderGeofence] = useState([]);
  // const [riderIdProofImage, setriderIdProofImage] = useState([]);
  // const [riderVechicleRCImages, setriderVechicleRCImages] = useState([]);
  // const [riderDLImages, setriderDLImages] = useState([]);
  // const [riderVechicleImages, setriderVechicleImages] = useState([]);
  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const { id, val } = props.match.params;
  var history = useHistory();
  // const csvData = [["560063"], ["560030"], ["560034"], ["560007"], ["560092"]];
  const handleClose1 = () => {
    setShow(false);
    setShow1(false);
  };
  const [geofenceadded, setgeofenceadded] = useState("");
  // const duplicateCheck = [];

  const handleShow1 = () => {
    setShow1(true);
  };
  const handleClose = () => setShow(false);

  const handleShow = () => {
    setView(false);
    // setshowdictpincodes1("false");
    // setshowstates("true");
    // setshowdistricts(false);
    setShow(true);
    axios
      .get(Baseurl.baseurl + `/health/get-all-geofence`)
      .then((res) => {
        let valArr = [];
        res.data.pincodes.map((val) => {
          if (val.VehicleTypes.includes(RiderVehicleType.name)) {
            valArr.push(val);
          }
        });
        setpincodes(valArr);
        setStateForSearch(valArr);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  function getData() {
    let arrImg = [];
    let listData = [];
    let riderDetImage = [];
    axios
      .get(
        Baseurl.baseurl +
          `/rider/get-rider-details/${id}`
      )
      .then((res) => {
        console.log("rider detail", res.data);
        if (res.data.message == "No Rider Found") {
        } else {
          setRiderData(res.data.rider);
          setRiderVehicleType(res.data.rider.RiderVehicleType);
          setRiderGeofence(res.data.rider.RiderGeoFence);
          setOnboardId(res.data.rider.riderOnboardingId);
          // setriderIdProofImage(res.data.rider.riderIdProofImage);
          // setriderVechicleRCImages(res.data.rider.riderVechicleRCImages);
          // setriderDLImages(res.data.rider.riderDLImages);
          // setriderVechicleImages(res.data.rider.riderVechicleImages);

          riderDetImage = [
            {
              title: "ID Proof",
              img: res.data.rider.riderIdProofImage,
            },
            {
              title: "DL Image",
              img: res.data.rider.riderDLImages,
            },
            {
              title: "RC Image",
              img: res.data.rider.riderVechicleRCImages,
            },
            {
              title: "Vehicle Image",
              img: res.data.rider.riderVechicleImages,
            },
          ];

          arrImg = [
            {
              title: "Concerned Form",
              img: res.data.rider.RiderFormImage,
            },
            {
              title: "Insurance Image",
              img: res.data.rider.InsuranceImage,
            },
            {
              title: "Medical Certificate",
              img: res.data.rider.riderMedicalCertificateImage,
            },
            {
              title: "Police Certificate",
              img: res.data.rider.riderPoliceCertificateImage,
            },
            {
              title: "Emmission Certificate",
              img: res.data.rider.riderVehicleEmissionCertificateImage,
            },
          ];

          listData = [
            {
              title: "First Name",
              data:
                res.data.rider.riderFirstName && res.data.rider.riderFirstName,
            },
            {
              title: "Last Name",
              data: res.data.rider.riderLastName && res.data.rider.riderLastName,
            },
            {
              title: "Father Name",
              data:
                res.data.rider.riderFatherName && res.data.rider.riderFatherName,
            },
            {
              title: "Contact No",
              data: res.data.rider.riderPhone && res.data.rider.riderPhone,
            },
            {
              title: "Alternate Number",
              data: res.data.rider.riderAlternatePhone,
            },
            {
              title: "Adharcard Number",
              data: res.data.rider.riderAadharNumber,
            },

            // {
            //   title: "Date of Birth",
            //   data: res.data.rider.riderDOB,
            // },
            {
              title: "City Name",
              data: res.data.rider.riderCityName,
            },
            {
              title: "Wallet",
              data:
                res.data.rider.riderWallet !== 0 && res.data.rider.riderWallet,
            },
            {
              title: "Service Type",
              data: res.data.rider.ServiceType && res.data.rider.ServiceType,
            },
            {
              title: "Vechile No",
              data:
                res.data.rider.riderVechicleNumber &&
                res.data.rider.riderVechicleNumber,
            },
            {
              title: "Vehicle Age",
              data: res.data.rider.VehicleAge !== 0 && res.data.rider.VehicleAge,
            },
            {
              title: "Razer pay ContactID",
              data: res.data.rider.Rzp_Contact_ID,
            },
            {
              title: "Razer pay FundID",
              data: res.data.rider.Rzp_Fund_ID,
            },
            {
              title: "Razer pay FavID",
              data: res.data.rider.Rzp_Fav_ID && res.data.rider.Rzp_Fav_ID,
            },
            // {
            //   title: "Email Address",
            //   data: res.data.rider.riderEmail,
            // },
            // {
            //   title: "Complete Address",
            //   data: res.data.rider.riderCompleteAddress,
            // },
            // {
            //   title: "Rider Location",
            //   data: res.data.rider.riderLocation,
            // },
            {
              title: "Total Orders",
              data:
                res.data.rider.orders.length !== 0 &&
                res.data.rider.orders.length,
            },
            {
              title: "Bank A/c no",
              data:
                res.data.rider.BankStatus &&
                res.data.rider.RiderBankAccountDetailsMain[0]
                  .RiderAccountNumber !== 0 &&
                res.data.rider.RiderBankAccountDetailsMain[0].RiderAccountNumber,
            },
            {
              title: "A/c Holder",
              data:
                res.data.rider.BankStatus &&
                res.data.rider.RiderBankAccountDetailsMain[0].RiderAccountName,
            },
            {
              title: "IFSC Code",
              data:
                res.data.rider.BankStatus &&
                res.data.rider.RiderBankAccountDetailsMain[0].RiderAccountIFSC,
            },
          ];
          setImgArray(arrImg);
          setRiderListData(listData);
          setRiderDetailsImage(riderDetImage);
        }

        // axios
        //   .get(
        //     `${Baseurl.baseurl}/onboarding/get-onboarding-by-id/${res.data.rider.riderOnboardingId}`
        //   )
        //   .then((res) => {
        //     if (res.data.onboarding) {
        //       setOnboardDetails(res.data.onboarding);
        //     }
        //   })
        //   .catch((err) => {
        //     if (err.toString() === "Error: Network Error") {
        //       history.push("/offline");
        //     } else {
        //       history.push("/400");
        //     }
        //   });
      })
      .catch((err) => {
        //console.log("errpr",err)
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  useEffect(() => {
    getData();
  }, []);
  const setitem = (id) => {
    axios
      .get(Baseurl.baseurl + `/go-geofence/get-geofence-by-id/${id}`)
      .then((res) => {
        setGeoPincodes(res.data.pincodes.PinCode);
        setForSearch(res.data.pincodes.PinCode);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  const setitemapi = (geoId) => {
    var Pincodes = {
      geofenceID: `${geoId}`,
    };
    axios
      .put(Baseurl.baseurl + `/go-geofence/assign-geofence/${id}`, Pincodes)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setgeofenceadded("added");
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  // const viewdict = (id) => {
  //   setshowstates("false");
  //   setshowdistricts("false");
  //   setshowdictpincodes1("true");
  //   axios.get(Baseurl.baseurl + `/go-pincode/get-pincode/${id}`).then((res) => {
  //     var pincode = res.data.pincodes.PinCode;
  //     // const obj = { ...pincode };
  //     var arrayOfObjs = pincode.map(function(val) {
  //       return { id: val };
  //     });

  //     setshowdictpincodes(arrayOfObjs);
  //     setForSearch(arrayOfObjs);
  //   });
  // };
  var str = " ";
  // function removeDuplicates(arr) {
  //   var counts = arr.reduce(function(counts, item) {
  //     counts[item] = (counts[item] || 0) + 1;
  //     return counts;
  //   }, {});
  //   return Object.keys(counts).reduce(function(arr, item) {
  //     if (counts[item] === 1) {
  //       arr.push(item);
  //     }
  //     if (counts[item] === 3) {
  //       arr.push(item);
  //     }
  //     return arr;
  //   }, []);
  // }
  // const addPin = () => {
  //   var Pincodes = {
  //     pincode: [...new Set(removeDuplicates(pincodes1))],
  //   };

  //   axios
  //     .put(Baseurl.baseurl + `/go-pincode/assign-pincode/${id}`, Pincodes)
  //     .then((response) => {
  //       if (response.data.status) {
  //         swal("Added", response.data.message, "success", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //         setgeofenceadded("added");
  //       } else {
  //         swal("Oops", response.data.message, "error", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //       }
  //       handleClose();
  //     });
  // };
  // const sub = (id) => {
  //   setpincodes1(
  //     (oldArray) => oldArray.concat(id),
  //     () => {}
  //   );
  // };

  const rejectrider = (e, r) => {
    setRejectSpinner(true);
    e.preventDefault();
    var data = {
      status: false,
      reason: rejectreason,
    };
    axios({
      url: `${Baseurl.baseurl}/rider/verify-rider/${id}`,
      data: data,
      method: "put",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.status) {
          swal("Rejected", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setgeofenceadded("added");
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setRejectSpinner(false);
        setShow1(false);
        history.push("/rider-applied");
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
        setRejectSpinner(false);
      });
  };
  const accept = () => {
    if (riderData.RiderGeoFence) {
      let amt = parseInt(amount);
      const params = JSON.stringify({
        status: true,
        oId: onboardId,
        amount: amt,
      });
      axios
        .put(`${Baseurl.baseurl}/rider/verify-rider/${id}`, params, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.status) {
            swal("Accepted", res.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            setSpinnerAccept(false);
            history.push("/rider-applied");
          } else {
            swal("Oops", res.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }

          handleClose1();
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      swal("Oops", "add geofence to the rider", "error", {
        button: "Done",
        timer: 1000,
      });
    }
  };
  function viewImage(img) {
    setShow1(true);
    setViewImage(img);
    setViewStatus(true);
  }
  function searchDist(value) {
    let filteredData = [];
    stateForSearch.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setpincodes(filteredData);
  }
  // function searchState(value) {
  //   let filteredData = [];
  //   stateForSearch.map((val) => {
  //     if (val.State.toLowerCase().includes(value)) {
  //       filteredData.push(val);
  //     }
  //   });
  //   setpincodes(filteredData);
  // }
  function searchPincode(value) {
    let filteredData = [];
    forSearch.map((val) => {
      let pinString = val.toString();
      if (pinString.includes(value)) {
        filteredData.push(val);
      }
    });
    setGeoPincodes(filteredData);
  }
  // function distictSelect(id) {
  //   axios.get(Baseurl.baseurl + `/go-pincode/get-pincode/${id}`).then((res) => {
  //     setpincodes1((oldArray) => oldArray.concat(res.data.pincodes.PinCode));
  //   });
  // }
  // function onChangeFile(file) {
  //   ExcelRenderer(file, (err, resp) => {
  //     if (err) {
  //       console.log(err);
  //     } else {
  //       let newRows = [];
  //       resp.rows.slice(0).map((row, index) => {
  //         if (row && row != "undefined" && row != "") {
  //           newRows.push(row[0]);
  //         }
  //       });
  //       console.log("vigga", newRows);
  //       setUploadData(newRows);
  //     }
  //   });
  // }
  // function addUploadPin() {
  //   var Pincodes = {
  //     pincode: [...new Set(uploadData)],
  //   };
  //   axios
  //     .put(Baseurl.baseurl + `/go-pincode/assign-pincode/${id}`, Pincodes)
  //     .then((response) => {
  //       if (response.data.status) {
  //         swal("Added", response.data.message, "success", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //         setgeofenceadded("added");
  //         setShow2(false);
  //       } else {
  //         swal("Oops", response.data.message, "error", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //       }
  //       handleClose();
  //     });
  // }
  // function onChangePicture(e, val) {
  //   e.preventDefault();
  //   if (e.target.files[0]) {
  //     setPicture(e.target.files[0]);
  //     // setPictureName(e.target.files[0].name);
  //     const reader = new FileReader();
  //     reader.addEventListener("load", () => {
  //       if (val == "emmission") {
  //         setEmmission(reader.result);
  //       }
  //       if (val == "concerned") {
  //         setConcerned(reader.result);
  //       }
  //       if (val == "health") {
  //         setHealth(reader.result);
  //       }
  //       if (val == "police") {
  //         setPolice(reader.result);
  //       }
  //       if (val == "vehicle") {
  //         setVehicle(reader.result);
  //       }
  //     });
  //     reader.readAsDataURL(e.target.files[0]);
  //   }
  // }
  return (
    <Col xl="12">
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          {/* <Modal
            size="lg"
            show={show2}
            onHide={() => {
              setShow2(false);
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <button className="btn btn-primary" onClick={() => {}}>
                  <CSVLink data={csvData} className="text-white">
                    Download Demo File
                  </CSVLink>
                  <i className="fa fa-download ml-2"></i>
                </button>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-sm-3">
                  <label>
                    <strong>Choose file to upload</strong>
                  </label>
                </div>
                <input
                  className="col-sm-9"
                  id="profilePic"
                  type="file"
                  onChange={(e) => {
                    onChangeFile(e.target.files[0]);
                  }}
                />
              </div>
              {uploadData && (
                <>
                  <table className="display w-100 dataTable responsive">
                    <thead>
                      <tr>
                        <th>
                          <strong>Pincodes</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {uploadData.map((val) => {
                        return (
                          <div className="col-sm-3">
                            <strong>{val}</strong>
                          </div>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              )}
            </Modal.Body>
            {uploadData && (
              <Modal.Footer>
                <button
                  className="btn btn-primary ml-3"
                  onClick={() => {
                    addUploadPin();
                  }}
                >
                  Submit
                </button>
              </Modal.Footer>
            )}
          </Modal> */}
          <Modal size="lg" show={show} onHide={handleClose}>
            <Modal.Body>
              {view && (
                <div className="row">
                  <div className="col-sm-8">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setView(false);
                      }}
                    >
                      Back
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchPincode(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
              {!view && (
                <div className="row">
                  <div className="col-sm-8"></div>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchDist(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
              {/* {showstates == "true" && (
                <div className="row">
                  <div className="col-sm-4">
                    <button
                      onClick={() => {
                        setShow2(true);
                        setShow1(false);
                      }}
                      className="btn btn-primary"
                    >
                      Upload File
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchState(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )} */}
              <Table id="myTable" responsive>
                {!view && (
                  <thead>
                    <tr>
                      <th>
                        <strong>Geofence Name</strong>
                      </th>
                      <th>
                        <strong>Category</strong>
                      </th>
                      <th>
                        <strong>View</strong>
                      </th>
                      <th>
                        <strong>Add</strong>
                      </th>
                    </tr>
                  </thead>
                )}
                {/* {showdictpincodes1 == "true" ? (
                  <thead>
                    <tr>
                      <th>
                        <strong>Pincodes</strong>
                      </th>
                    </tr>
                  </thead>
                ) : (
                  <thead>
                    <tr>
                      {showstates == "true" ? (
                        <>
                          <th>
                            <strong> STATE NAME</strong>
                          </th>
                          <th>
                            <strong>View</strong>
                          </th>
                          <th>
                            <strong>Add</strong>
                          </th>
                        </>
                      ) : (
                        <>
                          <th></th>
                          <th>
                            <strong> DISTRICT NAME</strong>
                          </th>
                          <th>
                            <strong>View</strong>
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                )} */}
                <tbody>
                  {view ? (
                    <Table responsive className="table table-striped">
                      <thead>
                        <tr>
                          <th>
                            <strong>Pincodes</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {geoPincodes &&
                          geoPincodes.map((i) => (
                            <tr>
                              <td>{i}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  ) : (
                    <>
                      {pincodes &&
                        pincodes.map((val) => {
                          return (
                            <tr>
                              <td>
                                <strong>{val.Name}</strong>
                              </td>
                              <td>
                                {val.VehicleTypes &&
                                  val.VehicleTypes.map((val) => {
                                    return (
                                      <div>
                                        <strong>{val}</strong>
                                      </div>
                                    );
                                  })}
                              </td>
                              <td>
                                <Link>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                      setitem(val._id);
                                      setView(true);
                                    }}
                                  >
                                    View
                                  </button>
                                </Link>
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => {
                                    setitemapi(val._id);
                                  }}
                                >
                                  ADD
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </>
                  )}
                  {/* {showstates == "true" &&
                    pincodes &&
                    pincodes
                      .map((data, index) => {
                        if (duplicateCheck.includes(data.State)) return null;
                        duplicateCheck.push(data.State);
                        return (
                          <tr>
                            {data.State ? <td>{data.State} </td> : null}
                            {data.State ? (
                              <td>
                                <Link>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                      setitem(data._id, data.State)
                                    }
                                  >
                                    View
                                  </button>
                                </Link>
                              </td>
                            ) : null}
                            {data.State ? (
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => setitemapi(data.State)}
                                >
                                  ADD
                                </button>
                              </td>
                            ) : null}
                          </tr>
                        );
                      })
                      .filter((e) => e)} */}
                  {/* {showdistricts == "true" &&
                    statepincodes.map((d, i) => (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            onClick={() => distictSelect(d._id)}
                            className="mb-3"
                            id="checkAll"
                            required
                          />
                        </td>
                        <td>{d.Name} </td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => viewdict(d._id)}
                          >
                            View
                          </button>
                        </td>
                       
                      </tr>
                    ))} */}
                </tbody>
              </Table>
              {/* {showdictpincodes1 == "true" && (
                <div>
                  <button
                    className="btn btn-primary mb-3"
                    onClick={() => {
                      setshowdictpincodes1("false");
                      setshowdistricts("true");
                    }}
                  >
                    Back
                  </button>
                  <div className="row mb-4">
                    <div className="col-sm-1 mt-2">
                      <label>
                        <strong>search</strong>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <input
                        value={search}
                        type="text"
                        className="form-control"
                        placeholder="Search Pincode"
                        onChange={(e) => {
                          setSearch(e.target.value);
                          searchPincode(e.target.value);
                        }}
                        required
                      />
                    </div>
                  </div>
                  {showdictpincodes.map((d, i) => (
                    <div className="row">
                      <tr>
                        <input
                          type="checkbox"
                          onClick={() => sub(d.id)}
                          className="mb-3"
                          id="checkAll"
                          required
                        />
                      </tr>
                      <tr className="ml-5">{d.id}</tr>
                    </div>
                  ))}
                  <button className="btn btn-primary" onClick={() => addPin()}>
                    ADD
                  </button>
                </div>
              )} */}
            </Modal.Body>
            {/* <Modal.Footer>
              {showdistricts == "true" && (
                <Button
                  variant="primary"
                  onClick={() => {
                    addPin();
                  }}
                >
                  ADD
                </Button>
              )}
              <Button variant="secondary" onClick={handleClose1}>
                Close
              </Button>
            </Modal.Footer> */}
          </Modal>
          <Modal size="lg" show={show1} onHide={handleClose1}>
            <form onSubmit={(e) => rejectrider(e, "reject")}>
              {" "}
              <Modal.Body>
                {viewStatus ? (
                  <div>
                    <img
                      alt=""
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      className="playerProfilePic_home_tile"
                      src={viewimage}
                    />
                  </div>
                ) : (
                  <div class="form-group">
                    <label for="comment">
                      <h4>Description</h4>
                    </label>
                    <textarea
                      placeholder="Enter Reason For Reject"
                      class="form-control"
                      rows="2"
                      id="comment"
                      onChange={(e) => {
                        setrejectreason(e.target.value);
                      }}
                      required
                    ></textarea>
                  </div>
                  // <h4>Are You Sure!! You Want to Reject Rider?</h4>
                )}
              </Modal.Body>
              {viewStatus ? null : (
                <Modal.Footer>
                  {/* <Button variant="secondary" onClick={handleClose1}>
                    Close
                  </Button> */}
                  {rejectSpinner ? (
                    <div className="ml-auto mr-2">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  ) : (
                    <Button variant="danger" type="submit">
                      Reject
                    </Button>
                  )}
                </Modal.Footer>
              )}
            </form>
          </Modal>
          <Card.Title className="text-white">Rider Details</Card.Title>
          <button
            className="btn btn-primary"
            onClick={() => {
              // if (riderData.RiderVerificationCheck) {
              //   if (riderData.Block) {
              //     history.push("/blocked-rider");
              //   } else {
              //     history.push("/riders");
              //   }
              // } else {
              //   if (riderData.Block) {
              //     history.push("/blocked-rider");
              //   } else {
              //     history.push("/rider-applied");
              //   }
              // }
              history.goBack();
            }}
          >
            Back
          </button>
        </Card.Header>
        <Card.Body>
          <Card.Text>
            <div className="profile-personal-info ">
              <div
                className="profile-photo"
                onClick={() => {
                  viewImage(riderData.riderProfileImage);
                }}
              >
                <img
                  src={riderData.riderProfileImage}
                  className="img-fluid rounded-circle"
                  alt="profile"
                  style={{ height: "100px", width: "100px" }}
                />
              </div>
              <br />
              {riderListData &&
                riderListData.map((val) => {
                  return (
                    <>
                      {val.data && (
                        <div className="row mb-2 ">
                          <div className="col-3 mt-1">
                            <h5 className="f-w-500 text-white ">
                              {val.title}
                              <span className="pull-right">:</span>
                            </h5>
                          </div>
                          <div className="col-9">
                            <span>{val.data} </span>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              <div className="row mb-2">
                <div className="col-3 mt-1">
                  <h5 className="f-w-500 text-white">
                    Smoke Or Drinks<span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-9">
                  <span>{riderData.riderSmokeOrDrink ? "Yes" : "No"}</span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-3 mt-1">
                  <h5 className="f-w-500 text-white">
                    Vechile type <span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-9">
                  <span>{RiderVehicleType.category}</span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-3 mt-1">
                  <h5 className="f-w-500 text-white">
                    Vechile Name<span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-9">
                  <span>{RiderVehicleType.name}</span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-3 mt-1">
                  <h5 className="f-w-500 text-white">
                    Vechile Own type<span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-9">
                  <span>{RiderVehicleType.rent == true ? "Rent" : "own"}</span>
                </div>
              </div>
              {/* <div className="row mb-2">
                <div className="col-3 mt-1">
                  <h5 className="f-w-500 text-white">
                    Onboard Name<span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-9">
                  <span>{onboardDetails.Name}</span>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-3 mt-1">
                  <h5 className="f-w-500 text-white">
                    Onboard Code<span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-9">
                  <span>{onboardDetails.CompanyCode}</span>
                </div>
              </div> */}

              {riderDetailsImage &&
                riderDetailsImage.map((val) => {
                  return (
                    <>
                      {val.img.length !== 0 && (
                        <div className="row mb-2 mt-3">
                          <div className="col-3 mt-5">
                            <h5 className="f-w-500 text-white">
                              {val.title}
                              <span className="pull-right">:</span>
                            </h5>
                          </div>
                          <div className="col-sm-9">
                            <div className="row">
                              {val.img &&
                                val.img.map((payload, index) => {
                                  return (
                                    <div
                                      onClick={() => {
                                        viewImage(payload);
                                      }}
                                      className="col-sm-4"
                                      style={{
                                        marginTop: "5px",
                                        width: 180,
                                        height: 100,
                                        aspectRatio: 1 * 1.4,
                                      }}
                                    >
                                      <img
                                        alt=""
                                        src={payload}
                                        style={{
                                          resizeMode: "cover",
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              {imgArray &&
                imgArray.map((val) => {
                  return (
                    <>
                      {val.img && (
                        <div className="row mb-2">
                          <div className="col-3 mt-5">
                            <h5 className="f-w-500 text-white">
                              {val.title}
                              <span className="pull-right">:</span>
                            </h5>
                          </div>
                          <div className="col-sm-9">
                            <div className="row">
                              <div
                                onClick={() => {
                                  viewImage(val.img);
                                }}
                                className="col-sm-4"
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                              >
                                <img
                                  alt=""
                                  src={val.img}
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              {/* <Link to="./state" onClick={() => localStorage.setItem("geofenceuserid", "123")}><span><strong>Add</strong></span></Link> */}
              {/* {!riderData.RiderVerificationCheck && (
                <div className="row mb-2">
                  <div className="col-3 mt-2 ">
                    <h5 className="f-w-500 text-white">
                      Add geofence
                      <span className="pull-right">:</span>
                    </h5>
                  </div>
                  <div className="col-9">
                    {riderData.RiderGeoFence ? (
                      <span>
                        <Link>
                          <button
                            onClick={() => handleShow()}
                            className="btn btn-primary ml-4"
                          >
                            Change
                          </button>
                        </Link>
                      </span>
                    ) : (
                      <span>
                        <Link>
                          <button
                            onClick={() => handleShow()}
                            className="btn btn-primary ml-4"
                          >
                            Add
                          </button>
                        </Link>
                      </span>
                    )}
                  </div>
                </div>
              )} */}
              {/* {riderData.RiderGeoFence && (
                <div className="row mb-2">
                  <div className="col-3 mt-3">
                    <h5 className="f-w-500 text-white">
                      View Geofence<span className="pull-right">:</span>
                    </h5>
                  </div>
                  <div className="col-9">
                    <span>
                      <button
                        style={{ paddingLeft: 28, paddingRight: 28 }}
                        onClick={() => {
                          setGeoView(!geoView);
                        }}
                        className="btn btn-primary ml-4"
                      >
                        {geoView ? "hide" : "view"}
                      </button>
                    </span>
                  </div>
                </div>
              )} */}

              {geoView && (
                <Table responsive className="table text-white">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Vehicle Type</th>
                      <th>
                        <strong>Pincodes</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{RiderGeofence.Name}</td>
                      <td>
                        {RiderGeofence.VehicleTypes.map((val) => {
                          return <text className="ml-2">{val}</text>;
                        })}
                      </td>
                      <td>
                        {RiderGeofence.PinCode.map((val) => {
                          return <text className="ml-2">{val}</text>;
                        })}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              )}
              {riderData.RiderVerificationCheck &&
                riderData.RegistrationCount === 4 && (
                  <div className="row mb-2 mt-4">
                    <div className="col-3 mt-3">
                      <h5 className="f-w-500 text-white">
                        Onboard Amount<span className="pull-right">:</span>
                      </h5>
                    </div>
                    <div>
                      <input
                        value={amount}
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        className="form-control"
                        placeholder="Enter Amount"
                        onChange={(e) => setAmount(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                )}
            </div>
          </Card.Text>
        </Card.Body>
        {localStorage.getItem("ridersapplied") == "true" && (
          <div>
            <Card.Footer className=" d-sm-flex justify-content-between align-items-center">
              {/* <Link to={"./rider-applied"} className="btn btn-primary">
                Back
              </Link> */}
              {spinnerAccept ? (
                <div className="ml-auto mr-2">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <>
                  {riderData.RiderGeoFence ? (
                    <button
                      className="btn btn-primary ml-auto mr-2"
                      onClick={(e) => {
                        setSpinnerAccept(true);
                        accept(e);
                      }}
                    >
                      Accept
                    </button>
                  ) : null}
                </>
              )}
              <button
                className="btn btn-danger ml-auto"
                onClick={() => {
                  handleShow1();
                  setViewStatus(false);
                }}
              >
                Reject
              </button>
            </Card.Footer>
          </div>
        )}
      </Card>
    </Col>
  );
}

export default RiderAcceptDetails;
